import { Box, Text, type BoxProps } from '@mantine/core'
import React from 'react'

import classes from '../styles.module.css'

export function AlertActionableTitle({
  children,
  ...props
}: React.PropsWithChildren<BoxProps>) {
  return (
    <Box className={classes.title} {...props}>
      <Text fw={500} c='brand.8'>
        {children}
      </Text>
    </Box>
  )
}
